export default "__VITE_ASSET__21e1271e__"